import { render, staticRenderFns } from "./diagnosisDetails.vue?vue&type=template&id=68e861b6&scoped=true"
import script from "./diagnosisDetails.vue?vue&type=script&lang=js"
export * from "./diagnosisDetails.vue?vue&type=script&lang=js"
import style0 from "./diagnosisDetails.vue?vue&type=style&index=0&id=68e861b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e861b6",
  null
  
)

export default component.exports